import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RefreshCw, X } from "lucide-react";
import { subscribe, applyUpdate, isCaptureActive, pendingUploads } from "@/lib/appUpdate";

export default function UpdateToast() {
  const { t } = useTranslation();
  const [st, setSt] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [camActive, setCamActive] = useState(isCaptureActive());
  const [uploads, setUploads] = useState(0);
  useEffect(() => subscribe(setSt), []);
  // Group A4: never show over the camera — tapping it mid-walkthrough would
  // reload and lose the recording. It reappears after Done / next app open.
  useEffect(() => {
    const f = (e) => setCamActive(!!e.detail?.active);
    window.addEventListener("bf:capture-state", f);
    return () => window.removeEventListener("bf:capture-state", f);
  }, []);
  // Round 16 B5: also hidden while the offline queue has pending uploads.
  useEffect(() => {
    const f = () => pendingUploads().then(setUploads).catch(() => {});
    f();
    window.addEventListener("bf:queue-changed", f);
    return () => window.removeEventListener("bf:queue-changed", f);
  }, []);
  if (!st?.updateAvailable || dismissed || camActive || uploads > 0) return null;
  return (
    <div data-testid="update-available-banner" role="status"
      className="fixed inset-x-0 top-0 z-[80] flex justify-center px-3 pt-[max(env(safe-area-inset-top,8px),12px)]">
      <div className="flex w-full max-w-md items-center gap-3 rounded-2xl border border-[#1473E6]/40 bg-[#071A33] px-4 py-3 text-white shadow-xl">
        <RefreshCw className="h-5 w-5 shrink-0 text-[#7FB3F2]" />
        <div className="min-w-0 flex-1">
          <div className="text-sm font-bold" data-testid="update-available-title">{t("upd_available_title")}</div>
          <div className="text-xs text-slate-300">{t("upd_available_body")}</div>
        </div>
        <button data-testid="update-now-btn" onClick={applyUpdate}
          className="min-h-[44px] shrink-0 rounded-full bg-[#1473E6] px-4 text-xs font-bold text-white active:scale-95">
          {t("upd_now")}
        </button>
        <button data-testid="update-later-btn" onClick={() => setDismissed(true)} aria-label={t("upd_later")}
          className="flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center rounded-full text-slate-300 hover:bg-white/10">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
